import { HttpClient } from '@angular/common/http';
import { IDataset } from '@app/core/model/datasets/dataset';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BytesPipe } from '@app/core/utilities/pipes/bytes.pipe';
import { StatusToDisplayName } from '@app/core/utilities/pipes/status-to-display-name.pipe';
import { DatasetSearchColumnFields, DatasetSearchGridOptionsFormatter } from '@app/search/gridOptions/dataset-search-grid-options-formatter';
import {
  MATCHER_NAME_COLUMN_WIDTH_REDUCTION,
  OverrideColumnDefinition,
  OverrideColumnParameters
} from '@app/search/gridOptions/search-grid-options-formatter';

export class DatasetResourceMatcherGridOptionsFormatter extends DatasetSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public bytesPipe: BytesPipe,
    public http: HttpClient,
    public statusToDisplayName: StatusToDisplayName
  ) {
    super(resourceDictionaryService, bsshDatePipe, bytesPipe, http, statusToDisplayName);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<DatasetSearchColumnFields> {
    const inclusiveColumns: DatasetSearchColumnFields[] = [
      DatasetSearchColumnFields.Name,
      DatasetSearchColumnFields.Analysis,
      DatasetSearchColumnFields.Project,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<DatasetSearchColumnFields>[] = [
      {
        colId: DatasetSearchColumnFields.Name,
        cellRendererParams: (params) => {
            if(params.data && params.data.Dataset && params.data.Dataset.AppSession && !params.data.Dataset.IsDeleted && !params.data.Dataset.IsArchived) {
                const resource = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as IDataset;
                const analysis = resource.AppSession;
                return DataTableUtilities.getRadLinkParams(
                    resource.Name,
                    BsApiEndPoints.getAppResultRoute(analysis.Id, resource.Id),
                    this.getUnselectableRowMessage(params.node),
                    null,
                    MATCHER_NAME_COLUMN_WIDTH_REDUCTION
                );
            } else if(params.data && params.data.Dataset) {
                const resource = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as IDataset;
                return DataTableUtilities.getRadLinkParams(
                    resource.Name,
                    null,
                    this.getUnselectableRowMessage(params.node),
                    null,
                    MATCHER_NAME_COLUMN_WIDTH_REDUCTION
                );
            } else {
                return {};
            }
        }
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}

